var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H11C10.4478 0 10 0.511786 10 1.14286C10 1.77393 10.4478 2.28571 11 2.28571H13C13.5522 2.28571 14 2.7975 14 3.42857V12.5714C14 13.2025 13.5522 13.7143 13 13.7143H11C10.4478 13.7143 10 14.2261 10 14.8571C10 15.4882 10.4478 16 11 16H13C14.6569 16 16 14.465 16 12.5714V3.42857C16 1.535 14.6562 0 13 0ZM10.7063 7.19286L6.70625 2.62143C6.31531 2.17464 5.6825 2.17536 5.29219 2.62143C4.90156 3.06786 4.90156 3.79107 5.29219 4.2375L7.5875 6.85714H1C0.447187 6.85714 0 7.36786 0 8C0 8.63214 0.447187 9.14286 1 9.14286H7.5875L5.29437 11.7636C4.90375 12.21 4.90375 12.9332 5.29437 13.3796C5.685 13.8261 6.31781 13.8261 6.70844 13.3796L10.7084 8.80822C11.0969 8.36071 11.0969 7.63929 10.7063 7.19286Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIco);
export default __webpack_public_path__ + "static/media/login_ico.0e3bd3f10b4d431992f2a2b5b068e543.svg";
export { ForwardRef as ReactComponent };